import { H5, P } from "../../../../AbstractElements";

const CardHolder = () => {
  return (
    <div className="d-flex balance-holder">
      <div className="flex-grow-1">
        <P className="m-0">Card Holder</P>
        <H5>Rara Avis</H5>
      </div>
      <div className="d-flex">
        <i className="icon-more-alt"> </i>
        <i className="icon-more-alt"> </i>
        <i className="icon-more-alt"> </i>
        <P className="m-0">1234 </P>
      </div>
    </div>
  );
};

export default CardHolder;
